import cloneDeep from 'clone-deep'
import { Frequency } from 'components/Frequency'
import { LayoutLoading } from 'components/LayoutLoading'
import { useEffect, useState } from 'react'
import { getACH, postACH } from 'services'
import { RenderInput } from 'utils/RenderInput'
import { setLoanNumber } from 'utils/setLoanNumber'

import { defaultInputs } from './constants'

export const ACH = () => {
  const [loading, setLoading] = useState(true)
  const [data, setData] = useState<any>({})
  const [orgData, setOrgData] = useState<any>({})
  const inputs = defaultInputs()

  useEffect(() => {
    setLoading(true)
    setLoanNumber()
    getACH()
      .then((res: any) => {
        if (res.success) {
          setData(res.data)
          setOrgData(res.data)
        }
      })
      .finally(() => setLoading(false))
  }, [])

  const onChange = async (key: string, value: string) => {
    if (loading) return
    const temp = cloneDeep(data)
    temp[key] = value
    setData(temp)
  }

  const onBlur = async (key: string, _value?: any) => {
    const value = data[key]
    if (!_value && value === orgData[key]) return
    setLoading(true)
    await postACH({
      key,
      value: _value || value,
    })
    setOrgData(data)
    setLoading(false)
  }

  return (
    <div className="servicing-note-container">
      <LayoutLoading show={loading} />
      <div className="w-full">
        <div className="grid grid-cols-3 gap-2">
          {Object.keys(inputs).map((key, index) => {
            const input = inputs[key]
            input.value = data[key]

            return (
              <div key={index} className={`col-span-${input.span || 1}`}>
                <RenderInput
                  input={input}
                  Key={key}
                  onChange={(key: string, value: any) => onChange(key, value)}
                  onBlur={(key: string) => onBlur(key)}
                />
              </div>
            )
          })}
        </div>
        <div className="mt-2">
          <Frequency
            data={data.frequency}
            onChange={(value: any) => {
              onChange('frequency', value)
              onBlur('frequency', value)
            }}
            errorCheck={false}
          />
        </div>
      </div>
    </div>
  )
}
